import { classifyPageSubdocId } from '@streamlain/database-identity';

export function isDatabaseRootCollectionDocId(
  docId: string,
  workspaceId: string
): boolean {
  return classifyPageSubdocId(docId, workspaceId)?.kind === 'database-root';
}

export function isDatabaseRowShardCollectionDocId(
  docId: string,
  workspaceId: string
): boolean {
  const subdoc = classifyPageSubdocId(docId, workspaceId);
  return subdoc?.kind === 'database-row-shard' && !subdoc.local;
}

export function isDatabaseSystemCollectionDocId(
  docId: string,
  workspaceId: string
): boolean {
  const subdoc = classifyPageSubdocId(docId, workspaceId);
  return (
    subdoc !== null &&
    subdoc.kind !== 'page_part' &&
    (subdoc.kind === 'database-root' || !subdoc.local)
  );
}
